import get from 'lodash/get';
$ const snackbarData = {
  snackbar: get(state, 'snackbar', {
    content: '',
    open: false,
    actionLinkText: ''
  }),
  isError: get(state, 'isError', false),
  responseType: get(state, 'responseType', ''),
  hostname: get(input, 'watchDataProvider.apiSettings.hostname', '')
};
<div>
  <favorite-snackbar-dialog ...snackbarData onSnackbarClose("onSnackbarClose")/>
</div>